/* Dependencies */
import styled from 'styled-components';

const TopBarText = styled.span.attrs(({ classname }: any) => ({
  className: classname ? `${classname} TopBarText` : 'TopBarText',
}))`
  font-size: 18px;
  padding: 0 10px;
  overflow: hidden;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: -0.5px;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.colors.topBarTextColor};
`;

export default TopBarText;
